<div
  class="relative flex min-h-12 w-full cursor-pointer items-center justify-between gap-3 rounded-xl px-4 py-2.5 transition-colors"
  [class.bg-standard-selected]="isSelected()"
  [class.text-primary-main]="isSelected()"
  [class.text-standard-text-primary]="!isSelected()">
  @if (isSelected()) {
    <span
      class="bg-primary-main absolute inset-y-2.5 left-0 w-1 rounded-r-full"
      aria-hidden="true"></span>
  }

  <div class="flex min-w-0 items-center gap-3">
    <span class="material-symbols-rounded text-2xl!" aria-hidden="true">
      {{ getTicketSortIcon(ticketSort().ticketType) }}
    </span>
    <span class="truncate text-base {{ isEdited() ? 'font-extrabold' : '' }}">{{
      ticketSort().name
    }}</span>
  </div>

  @if (!isLayoutCompleted()) {
    <span
      class="material-symbols-rounded text-warning-on shrink-0 text-2xl!"
      aria-hidden="true">
      warning
    </span>
  }
</div>
